import React, { useCallback, useEffect, useRef, useState } from 'react';
import { CircularProgress, Grid, Skeleton, Stack, Typography } from '@mui/material';
import PropertyCard from "../../components/propertyCard";
import CustomIcon from "../../components/customIcon";
import listingService from "../../services/listingServices";
import { useSelector } from 'react-redux';


export default function CompletedAssets() {
  const user = useSelector(state => state.user.data);
  const [listings, setListings] = useState([]);
  const [url, setUrl] = useState("");
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const [loading, setLoading] = useState(true);
  const [initialLoad, setInitialLoad] = useState(true);

  const observer = useRef();

  const lastElementRef = useCallback((node) => {
    if (loading) return;
    if (observer.current) observer.current.disconnect();

    observer.current = new IntersectionObserver(entries => {
      if (entries[0].isIntersecting && hasMore) {
        setPage(prev => prev + 1);
      }
    });

    if (node) observer.current.observe(node);
  }, [loading, hasMore]);

  const fetchListings = async (pageToFetch) => {
    let membershiptype = user?.membershiptype;
    setLoading(true);

    try {
      const res = await listingService.getApprovedListing(user?._id, pageToFetch, 9, membershiptype, true);

      if (res && res.success) {

        const newListings = res.data;

        const total = res.noOfEntries || 0;

        if (newListings.length === 0) {
          setHasMore(false); // Stop further fetching
          return;
        }

        setUrl(res.url);
        setListings(prev => {
          const updated = [...prev, ...newListings];
          setHasMore(updated.length < total);
          return updated;
        });
      } else {
        // Optional: handle unexpected error structure
        setHasMore(false);
        console.warn("Unexpected response format:", res);
      }

    } catch (error) {
      console.error("Failed to fetch listings:", error);
      setHasMore(false); // Prevent infinite loop on error
    } finally {
      setLoading(false); // Always turn off loading (even on error)
      setInitialLoad(false);
    }
  };


  useEffect(() => {
    if (!user?._id) return;
    fetchListings(page)
  }, [page, user])

   

  return (


    <>
      {!initialLoad && !loading && listings.length === 0 ? (
        <Stack alignItems="center" justifyContent="center" spacing={2} sx={{ py: 10, width: "100%" }}>
          <CustomIcon name="building" size={64} style={{ opacity: 0.35 }} />
          <Typography variant="h5" color="text.secondary" fontWeight={600}>
            No Completed Assets
          </Typography>
          <Typography variant="body1" color="text.disabled" textAlign="center" maxWidth={400}>
            There are no completed assets to display right now. Please check back later as properties reach completion.
          </Typography>
        </Stack>
      ) : (
        <Grid container spacing={3}>
          {listings.map((e, i) => {
            const isLastElement = i === listings.length - 1;
            return (
              <Grid
                item
                lg={4} md={6} sm={6} xs={12}
                key={e._id || i}
                ref={isLastElement ? lastElementRef : null}
                sx={{ display: { md: 'flex' }, justifyContent: 'center', minWidth: '0' }}
              >
                <PropertyCard data={e} url={url} />
              </Grid>
            );
          })}
          {!initialLoad && loading && hasMore && [...Array(6)].map((_, index) => (
            <Grid key={index} item lg={4} md={6} sm={6} xs={12} sx={{ display: { md: 'flex' }, justifyContent: 'center', minWidth: '0' }}>
              <Skeleton sx={{ width: "500px" }} height={500} />
            </Grid>
          ))}
        </Grid>
      )}

      {initialLoad && (
        <Grid container columnSpacing={3} rowSpacing={3}>
          {[...Array(6)].map((_, index) => (
            <Grid key={index} item lg={4} md={6} sm={6} xs={12} sx={{ display: { md: 'flex' }, justifyContent: 'center', minWidth: '0' }}>
              <Skeleton variant="rounded" sx={{ width: "100%", maxWidth: 500, borderRadius: 2 }} height={350} />
            </Grid>
          ))}
        </Grid>
      )}
    </>
  )

}